'use strict';

var MarketProductGroupTDChartPOSFilterFactory = function MarketProductGroupTDChartPOSFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketProductGroupDowFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartPOSFilter() {
    DemandFilter.call(this, 'market-product-group', 'thematic-demand-chart-market-pos');
    this.registerFilters(injectedFilters);
  }
  TDChartPOSFilter.constructor = TDChartPOSFilter;
  TDChartPOSFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartPOSFilter;
};
MarketProductGroupTDChartPOSFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupTDChartPOSFilterFactory;